'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigurationContentModel = exports.AuthRouteContentModel = exports.RegisteredAuthStrategyContentModel = exports.RegisteredShellContentModel = exports.RegisteredActivityContentModel = exports.RoleContentModel = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _class2, _temp2, _dec2, _desc2, _value2, _class3, _descriptor4, _descriptor5, _class4, _temp3, _dec3, _desc3, _value3, _class5, _descriptor6, _descriptor7, _class6, _temp4, _dec4, _desc4, _value4, _class7, _descriptor8, _descriptor9, _class8, _temp5, _dec5, _dec6, _dec7, _dec8, _desc5, _value5, _class9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class10, _temp6, _dec9, _dec10, _dec11, _dec12, _dec13, _desc6, _value6, _class11, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _class12, _temp7;

var _mobx = require('mobx');

var _collectionGridEditor = require('collection-grid-editor');

var _collectionGridEditor2 = _interopRequireDefault(_collectionGridEditor);

var _editor = require('./editor');

var _editor2 = _interopRequireDefault(_editor);

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _typeEntity = require('type-entity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

// export class PermissionsContentModel extends BaseContentModel{
//   static _slots = {
//     canConfigure: [RoleContentModel],
//     canCreate: [RoleContentModel],
//     canEdit: [RoleContentModel],
//     canApprove: [RoleContentModel],
//     canFacilitate: [RoleContentModel],
//     canParticipate: [RoleContentModel]
//   }
//   /* @slot( RoleContentModel ) */ @observable.shallow canConfigure = [1]
//   /* @slot( RoleContentModel ) */ @observable.shallow canCreate = [1]
//   /* @slot( RoleContentModel ) */ @observable.shallow canEdit = [1,4,5]
//   /* @slot( RoleContentModel ) */ @observable.shallow canApprove = [1,4,5]
//   /* @slot( RoleContentModel ) */ @observable.shallow canFacilitate = [1,3,4]
//   /* @slot( RoleContentModel ) */ @observable.shallow canParticipate = [2]
// }

var RoleContentModel = exports.RoleContentModel = (_dec = _mobx.observable.shallow, (_class = (_temp2 = _class2 = function (_BaseContentModel) {
  (0, _inherits3.default)(RoleContentModel, _BaseContentModel);

  function RoleContentModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RoleContentModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RoleContentModel.__proto__ || (0, _getPrototypeOf2.default)(RoleContentModel)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'roleType', _descriptor, _this), _initDefineProp(_this, 'roleId', _descriptor2, _this), _initDefineProp(_this, 'readOnlyAccessTypes', _descriptor3, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /* @slot */ //for ex: superadmin
  /* @slot */ //for ex: 1
  /* @slot( TypeContentModel ) */

  (0, _createClass3.default)(RoleContentModel, [{
    key: 'getComponent',
    value: function getComponent() {
      return (0, _get3.default)(RoleContentModel.prototype.__proto__ || (0, _getPrototypeOf2.default)(RoleContentModel.prototype), 'getComponent', this).call(this, { forceBasicEditor: true });
    }
  }]);
  return RoleContentModel;
}(_baseContentmodel2.default), _class2._slots = {
  roleType: "",
  roleId: 0,
  readOnlyAccessTypes: [_typeEntity.ContentModel] }, _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'roleType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'roleId', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'readOnlyAccessTypes', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class));

// export class RolePermissionContentModel extends BaseContentModel{
//   static _slots = {
//     role: RoleContentModel,
//     type: BaseContentModel,
//     canCreate: true,
//     canEdit: true,
//     canApprove: true,
//     canDelete: true
//   }
//   /* @slot( RoleContentModel ) */ @observable.ref role = null
//   /* @slot( BaseContentModel ) */ @observable.ref type = null
//   /* @slot */ @observable canCreate = true
//   /* @slot */ @observable canEdit = true
//   /* @slot */ @observable canApprove = true
//   /* @slot */ @observable canDelete = true
// }

var RegisteredActivityContentModel = exports.RegisteredActivityContentModel = (_dec2 = _mobx.observable.ref, (_class3 = (_temp3 = _class4 = function (_BaseContentModel2) {
  (0, _inherits3.default)(RegisteredActivityContentModel, _BaseContentModel2);

  function RegisteredActivityContentModel(props) {
    (0, _classCallCheck3.default)(this, RegisteredActivityContentModel);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (RegisteredActivityContentModel.__proto__ || (0, _getPrototypeOf2.default)(RegisteredActivityContentModel)).apply(this, arguments));

    _initDefineProp(_this2, 'path', _descriptor4, _this2);

    _initDefineProp(_this2, 'module', _descriptor5, _this2);

    var webpackLoader = _this2.$parent.webpackLoader;
    if (!webpackLoader) throw new Error("missing webpack loader!");
    _this2.module = webpackLoader(_this2.path);
    return _this2;
  }
  // static _meta = {
  //   version: {
  //     readonly: true
  //   },
  //   hasUnitTests: {
  //     readonly: true
  //   },
  //   hasCustomView: {
  //     readonly: true
  //   },
  //   hasSampleData: {
  //     readonly: true
  //   },
  //   hasBaseStylesheet: {
  //     readonly: true
  //   },
  //   isInGitlab: {
  //     readonly: true
  //   },
  //   hasDocumentation: {
  //     readonly: true
  //   }
  // }


  (0, _createClass3.default)(RegisteredActivityContentModel, [{
    key: 'getFile',
    value: function getFile(file) {
      var webpackLoader = this.$parent.webpackLoader;
      if (!webpackLoader) throw new Error("missing webpack loader!");
      return webpackLoader(this.path + "/" + file);
    }
  }, {
    key: 'ContentModelName',
    get: function get() {
      return this.module && this.module.ContentModel && this.module.ContentModel.name;
    }
  }, {
    key: 'packageJson',
    get: function get() {
      return this.getFile("package.json");
    }
  }, {
    key: 'version',
    get: function get() {
      return this.packageJson && this.packageJson.version || "×";
    }
  }, {
    key: 'hasCustomView',
    get: function get() {
      return !!this.getFile("src/component") || !!this.getFile("src/component") || !!this.getFile("component") ? "✔" : "×";
    }
  }, {
    key: 'hasSampleData',
    get: function get() {
      return !!this.getFile("src/fixture") || !!this.getFile("dist/fixture") || !!this.getFile("fixture") ? "✔" : "×";
    }
  }, {
    key: 'hasBaseStylesheet',
    get: function get() {
      return !!this.getFile("src/style.css") || !!this.getFile("dist/style.css") || !!this.getFile("style.css") ? "✔" : "×";
    }
  }, {
    key: 'isInGitlab',
    get: function get() {
      return !!this.packageJson && !!this.packageJson.repository && !!this.packageJson.repository.url && this.packageJson.repository.url.indexOf("gitlab") > -1 ? "✔" : "×";
    }
  }, {
    key: 'hasDocumentation',
    get: function get() {
      return !!this.getFile("README.md") ? "✔" : "×";
    }
  }]);
  return RegisteredActivityContentModel;
}(_baseContentmodel2.default), _class4._slots = {
  path: "",
  version: "",
  hasUnitTests: "",
  hasCustomView: "",
  hasSampleData: "",
  hasBaseStylesheet: "",
  isInGitlab: "",
  hasDocumentation: "" }, _class4.readonly = true, _class4.savable = false, _temp3), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'path', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, 'module', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class3.prototype, 'ContentModelName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'ContentModelName'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'packageJson', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'packageJson'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'version', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'version'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasCustomView', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasCustomView'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasSampleData', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasSampleData'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasBaseStylesheet', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasBaseStylesheet'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'isInGitlab', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'isInGitlab'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'hasDocumentation', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'hasDocumentation'), _class3.prototype)), _class3));
var RegisteredShellContentModel = exports.RegisteredShellContentModel = (_dec3 = _mobx.observable.ref, (_class5 = (_temp4 = _class6 = function (_BaseContentModel3) {
  (0, _inherits3.default)(RegisteredShellContentModel, _BaseContentModel3);

  function RegisteredShellContentModel(props) {
    (0, _classCallCheck3.default)(this, RegisteredShellContentModel);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (RegisteredShellContentModel.__proto__ || (0, _getPrototypeOf2.default)(RegisteredShellContentModel)).apply(this, arguments));

    _initDefineProp(_this3, 'path', _descriptor6, _this3);

    _initDefineProp(_this3, 'module', _descriptor7, _this3);

    var webpackLoader = _this3.$parent.webpackLoader;
    if (!webpackLoader) throw new Error("missing webpack loader!");
    _this3.module = webpackLoader(_this3.path);
    return _this3;
  }
  /* @slot */

  (0, _createClass3.default)(RegisteredShellContentModel, [{
    key: 'ContentModelName',
    get: function get() {
      return this.module && this.module.ContentModel && this.module.ContentModel.name;
    }
  }]);
  return RegisteredShellContentModel;
}(_baseContentmodel2.default), _class6._slots = {
  path: "" }, _class6.readonly = true, _class6.savable = false, _temp4), (_descriptor6 = _applyDecoratedDescriptor(_class5.prototype, 'path', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class5.prototype, 'module', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class5.prototype, 'ContentModelName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'ContentModelName'), _class5.prototype)), _class5));
var RegisteredAuthStrategyContentModel = exports.RegisteredAuthStrategyContentModel = (_dec4 = _mobx.observable.ref, (_class7 = (_temp5 = _class8 = function (_BaseContentModel4) {
  (0, _inherits3.default)(RegisteredAuthStrategyContentModel, _BaseContentModel4);

  function RegisteredAuthStrategyContentModel(props) {
    (0, _classCallCheck3.default)(this, RegisteredAuthStrategyContentModel);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (RegisteredAuthStrategyContentModel.__proto__ || (0, _getPrototypeOf2.default)(RegisteredAuthStrategyContentModel)).apply(this, arguments));

    _initDefineProp(_this4, 'path', _descriptor8, _this4);

    _initDefineProp(_this4, 'module', _descriptor9, _this4);

    var webpackLoader = _this4.$parent.webpackLoader;
    if (!webpackLoader) throw new Error("missing webpack loader!");
    _this4.module = webpackLoader(_this4.path);
    return _this4;
  }
  /* @slot */

  (0, _createClass3.default)(RegisteredAuthStrategyContentModel, [{
    key: 'ContentModelName',
    get: function get() {
      return this.module && this.module.ContentModel && this.module.ContentModel.name;
    }
  }]);
  return RegisteredAuthStrategyContentModel;
}(_baseContentmodel2.default), _class8._slots = {
  path: "" }, _class8.readonly = true, _class8.savable = false, _temp5), (_descriptor8 = _applyDecoratedDescriptor(_class7.prototype, 'path', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class7.prototype, 'module', [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class7.prototype, 'ContentModelName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class7.prototype, 'ContentModelName'), _class7.prototype)), _class7));
var AuthRouteContentModel = exports.AuthRouteContentModel = (_dec5 = _mobx.observable.ref, _dec6 = _mobx.observable.ref, _dec7 = _mobx.observable.shallow, _dec8 = _mobx.observable.shallow, (_class9 = (_temp6 = _class10 = function (_BaseContentModel5) {
  (0, _inherits3.default)(AuthRouteContentModel, _BaseContentModel5);

  function AuthRouteContentModel(props) {
    (0, _classCallCheck3.default)(this, AuthRouteContentModel);

    // this converts "role" to "roles" array (back port roles)
    if (props.role && !(props.roles && props.roles.length)) {
      if (props.roles) props.roles.push(props.role);else props.roles = [props.role];
    }

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (AuthRouteContentModel.__proto__ || (0, _getPrototypeOf2.default)(AuthRouteContentModel)).apply(this, arguments));

    _this5.Editor = _editor.RouteEditor;

    _initDefineProp(_this5, 'authStrategyType', _descriptor10, _this5);

    _initDefineProp(_this5, 'authStrategy', _descriptor11, _this5);

    _initDefineProp(_this5, 'urlmatch', _descriptor12, _this5);

    _initDefineProp(_this5, 'roles', _descriptor13, _this5);

    _initDefineProp(_this5, 'destinations', _descriptor14, _this5);

    if (props.registeredAuthStrategies) {
      _this5.registeredAuthStrategies = props.registeredAuthStrategies;
    } else if (_this5.$parent) {
      _this5.registeredAuthStrategies = _this5.$parent.types.RegisteredAuthStrategyContentModel.allEntities();
    } else {
      throw new Error("unable to find registeredAuthStrategies");
    }

    // @TODO we should do this for all content model slots that are strings:
    _this5.$parent && (0, _mobx.when)(function () {
      return _this5.$parent.hasHydrated;
    }, function () {
      return _this5.destinations.forEach(function (destination, i, arr) {
        if (typeof destination === "string") {
          arr[i] = _this5.$parent.entities.get(destination) || destination;
        }
      });
    });

    return _this5;
  }

  /* @slot( RegisteredAuthStrategyContentModel ) */
  /* @slot( BaseContentModel ) */
  /* @slot */
  /* @slot( [RoleContentModel] ) */
  /* @slot( BaseContentModel ) */

  (0, _createClass3.default)(AuthRouteContentModel, [{
    key: 'createAuthStrategy',
    value: function createAuthStrategy() {
      this.authStrategy = new this.AuthStrategyContentModel({ isNew: true, id: this.id + "_authStrategy" });
    }
  }, {
    key: 'getComponent',
    value: function getComponent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.isNew) {
        return (0, _get3.default)(AuthRouteContentModel.prototype.__proto__ || (0, _getPrototypeOf2.default)(AuthRouteContentModel.prototype), 'getComponent', this).call(this, opts);
      } else {
        return (0, _get3.default)(AuthRouteContentModel.prototype.__proto__ || (0, _getPrototypeOf2.default)(AuthRouteContentModel.prototype), 'getComponent', this).call(this, { forceBasicEditor: true });
      }
    }
  }, {
    key: 'AuthStrategyContentModel',
    get: function get() {
      return this.authStrategyType && this.authStrategyType.module && this.authStrategyType.module.ContentModel;
    }
  }, {
    key: 'authStrategyDescription',
    get: function get() {
      return this.authStrategyType && this.authStrategyType.module && this.authStrategyType.module.description;
    }
  }, {
    key: 'invalid',
    get: function get() {
      var invalid = (0, _assign2.default)({}, this._invalid);
      if (!this.authStrategyType) invalid.authStrategyType = "Please choose an authStrategyType";
      if (!this.roles.length) invalid.roles = "Please choose a role";
      // if(!this.destination) invalid.destination = "Please choose destination(s) for this route";
      if (!this.destinations.length) invalid.destinations = "Please choose destination(s) for this route";
      if (this.authStrategy && this.authStrategy.isNew && this.authStrategy.allChildCms.length && this.authStrategy.allChildCms.some(function (cm) {
        return cm[0].isNew;
      })) {
        invalid.authStrategy = "Please save all submodels";
      }
      return invalid;
    }
  }]);
  return AuthRouteContentModel;
}(_baseContentmodel2.default), _class10._slots = {
  authStrategyType: RegisteredAuthStrategyContentModel,
  authStrategy: _baseContentmodel2.default,
  urlmatch: "",
  roles: [RoleContentModel],
  destinations: [_baseContentmodel2.default]
}, _temp6), (_descriptor10 = _applyDecoratedDescriptor(_class9.prototype, 'authStrategyType', [_dec5], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class9.prototype, 'authStrategy', [_dec6], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class9.prototype, 'urlmatch', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class9.prototype, 'roles', [_dec7], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class9.prototype, 'destinations', [_dec8], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class9.prototype, 'AuthStrategyContentModel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, 'AuthStrategyContentModel'), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, 'authStrategyDescription', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, 'authStrategyDescription'), _class9.prototype), _applyDecoratedDescriptor(_class9.prototype, 'invalid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class9.prototype, 'invalid'), _class9.prototype)), _class9));
var ConfigurationContentModel = exports.ConfigurationContentModel = (_dec9 = _mobx.observable.shallow, _dec10 = _mobx.observable.shallow, _dec11 = _mobx.observable.shallow, _dec12 = _mobx.observable.shallow, _dec13 = _mobx.observable.shallow, (_class11 = (_temp7 = _class12 = function (_BaseContentModel6) {
  (0, _inherits3.default)(ConfigurationContentModel, _BaseContentModel6);

  function ConfigurationContentModel(props) {
    (0, _classCallCheck3.default)(this, ConfigurationContentModel);

    // if(!app) throw new Error("missing app!");
    var _this6 = (0, _possibleConstructorReturn3.default)(this, (ConfigurationContentModel.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationContentModel)).apply(this, arguments));

    _initDefineProp(_this6, 'registeredActivities', _descriptor15, _this6);

    _initDefineProp(_this6, 'registeredAuthStrategies', _descriptor16, _this6);

    _initDefineProp(_this6, 'registeredShells', _descriptor17, _this6);

    _initDefineProp(_this6, 'roles', _descriptor18, _this6);

    _initDefineProp(_this6, 'routes', _descriptor19, _this6);

    _initDefineProp(_this6, 'pathTypes', _descriptor20, _this6);

    _initDefineProp(_this6, 'icon', _descriptor21, _this6);

    var webpackLoader = _this6.$parent.webpackLoader;
    _this6.registeredActivities = webpackLoader.keys("activity").map(function (k) {
      var registeredActivity = new RegisteredActivityContentModel({
        guid: k,
        id: k,
        path: k,
        readonly: true
      });
      if (_this6.$parent) {
        _this6.$parent.entities.set(k, registeredActivity);
      } else {
        console.warn("no $parent to attach entity to!");
      }
      return registeredActivity;
    });
    _this6.registeredShells = webpackLoader.keys("shell").map(function (k) {
      var registeredShell = new RegisteredShellContentModel({
        guid: k,
        id: k,
        path: k,
        readonly: true
      });
      if (_this6.$parent) {
        _this6.$parent.entities.set(k, registeredShell);
      } else {
        console.warn("no $parent to attach entity to!");
      }
      return registeredShell;
    });
    _this6.registeredAuthStrategies = webpackLoader.keys("auth-strategy").map(function (k) {
      var registeredAuthStrategy = new RegisteredAuthStrategyContentModel({
        guid: k,
        id: k,
        path: k,
        readonly: true
      });
      if (_this6.$parent) {
        _this6.$parent.entities.set(k, registeredAuthStrategy);
      } else {
        console.warn("no $parent to attach entity to!");
      }
      return registeredAuthStrategy;
    });
    return _this6;
  }

  (0, _createClass3.default)(ConfigurationContentModel, [{
    key: 'getComponent',

    // /* @slot( RolePermissionContentModel ) */ @observable.shallow rolePermissions = []
    value: function getComponent() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // if(opts.init){
      return _editor2.default;
      // }
      // return super.getComponent(opts);
    }
    // /* @slot( PermissionsContentModel ) */ @observable.ref permissions = null
    /* @readonly @slot( RegisteredActivityContentModel ) */
    /* @readonly @slot( RegisteredAuthStrategyContentModel ) */
    /* @readonly @slot( RegisteredShellContentModel ) */
    /* @slot( RoleContentModel ) */
    /* @slot( AuthRouteContentModel ) */
    /* @slot */
  }, {
    key: 'warning',
    get: function get() {
      var warning = {};
      var routesCheck = [];
      var hasDuplicateRoute = false;
      if (!this.roles.some(function (r) {
        return r.roleId === 1;
      })) {
        warning.noAdminRole = "You need at least 1 admin role.";
      }
      if (!this.routes.some(function (r) {
        return r.roles.some(function (role) {
          return role.roleId === 1;
        });
      })) {
        warning.noAdminRoute = "You need at least 1 admin route.";
      }
      this.routes.some(function (r) {
        if (routesCheck.indexOf(r.urlmatch) > -1) {
          warning.duplicateRoutes = 'You have a duplicate route url: ' + r.urlmatch + ' from contentmodel: ' + r.id;
          return true;
        }
        routesCheck.push(r.urlmatch);
      });

      return warning;
    }
  }]);
  return ConfigurationContentModel;
}(_baseContentmodel2.default), _class12._slots = {
  // permissions: PermissionsContentModel,
  registeredActivities: [RegisteredActivityContentModel],
  registeredShells: [RegisteredShellContentModel],
  registeredAuthStrategies: [RegisteredAuthStrategyContentModel],
  roles: [RoleContentModel],
  routes: [AuthRouteContentModel],
  pathTypes: "Array",
  icon: ""
  // rolePermissions: [RolePermissionContentModel]
}, _class12._meta = {
  registeredActivities: {
    readonly: true
  },
  registeredAuthStrategies: {
    readonly: true
  }
}, _temp7), (_applyDecoratedDescriptor(_class11.prototype, 'warning', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class11.prototype, 'warning'), _class11.prototype), _descriptor15 = _applyDecoratedDescriptor(_class11.prototype, 'registeredActivities', [_dec9], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class11.prototype, 'registeredAuthStrategies', [_dec10], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class11.prototype, 'registeredShells', [_dec11], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class11.prototype, 'roles', [_dec12], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class11.prototype, 'routes', [_dec13], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class11.prototype, 'pathTypes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class11.prototype, 'icon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return "system-icon";
  }
})), _class11));
var _default = ConfigurationContentModel;
exports.default = _default;
;

var _temp8 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RoleContentModel, 'RoleContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(RegisteredActivityContentModel, 'RegisteredActivityContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(RegisteredShellContentModel, 'RegisteredShellContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(RegisteredAuthStrategyContentModel, 'RegisteredAuthStrategyContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(AuthRouteContentModel, 'AuthRouteContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(ConfigurationContentModel, 'ConfigurationContentModel', 'src/entity_modules/configuration-entity/contentmodel.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/configuration-entity/contentmodel.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/configuration-entity/contentmodel.js
// module chunks = 0